import { Location } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { GlobalService } from 'src/app/_services/global.service';
@Component({
    selector: 'app-job-details',
    templateUrl: './job-details.component.html',
    styleUrls: ['./job-details.component.scss'],
    standalone: false
})
export class JobDetailsComponent implements OnInit {

  showProjectDetailsTab: Boolean = true;
  showEvaluationCriteriaTab: Boolean = false;
  showProjectLoader: Boolean = false;

  jobid: string = '';
  jobDetails: any;

  successMessage: String = '';
  errorMessage: String = '';
  showSpinnerLoader: Boolean = false;

  /** Regex to check valid project name */
  inputRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;


  /** Handler rename project */
  renameProjectInput: UntypedFormControl = new UntypedFormControl(null);
  renameProjectInputError: Boolean = false;
  renameProjectInputSpecialCharError: Boolean = false;
  selectedRenameProject: any;
  projectDescription:any;
  targetIndustries:any;
  projectSkills:any;
  targetCompanies:any;

  tab: Boolean = true;
  infoMessage: string = ''

  @ViewChild('renameProjectModel') renameProjectModel: TemplateRef<any>;
  @ViewChild('handleBackEventModel') handleBackEventModel: TemplateRef<any>;


  constructor(
    private modelService: NgbModal,
    private router: Router,
    private locationService: Location,
    private aiSourcingService: AiSourcingService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private atsResumeScreenService: AtsResumeScreenService
  ) { }

  ngOnInit() {
    this.jobid = window.location.pathname?.split('/')[3];
    this.aiSourcingHandlerService.setEvaluationTabEvent(false);
    this.getJobDetails();

  }


  /**
   * Method to handle change tab
   * @param type
   */
  onTabChange(type: String) {
    switch (type) {
      case 'project-tab': {
        this.showProjectDetailsTab = true;
        this.showEvaluationCriteriaTab = false;
        this.aiSourcingHandlerService.setEvaluationTabEvent(false);
        break;
      }

      case 'evaluation-tab': {
        this.showEvaluationCriteriaTab = true;
        this.showProjectDetailsTab = false;
        this.aiSourcingHandlerService.setEvaluationTabEvent(true);
        break;
      }
    }
  };

  /**
   * Method to fetch job details
   */
  getJobDetails() {
    this.atsResumeScreenService.getSingleJobDetails(this.jobid).subscribe((res: any) => {
      if (res && res.body && res.body.status == 'success') {
        this.jobDetails = res.body;
        this.projectDescription = this.jobDetails?.data?.description?.replace(/\n/g, "<br>");
      } else {
        this.jobDetails = {};
      }
    })
  };


removeSpecialCharacters(input: string): string {
    return input?.replace(/[^a-zA-Z0-9 ]/g, '');
  }

  /**
   * Method to handle the renaming of a project.    
   */
  openRenameProjectModel(project: any) {
    this.selectedRenameProject = project.data;
    this.renameProjectInput.setValue(project?.data?.name ? project?.data?.name : null);
    this.modelService.open(this.renameProjectModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Rename Job Name
   * @returns
   */
  renameProject() {
    if ((!this.renameProjectInput.value && !this.selectedRenameProject?.ats_job_id) || this.renameProjectInputSpecialCharError) return;
    this.showSpinnerLoader = true;
    const jobName = {
      name: this.renameProjectInput.value.trim()
    };
    const jobId = this.selectedRenameProject?.ats_job_id;   

    this.atsResumeScreenService.renameJob(jobId, jobName).subscribe((res: any) => {
      if (res && res.body && res.body.status == 'success') {
        this.successMessage = res.body.message;
        this.getJobDetails();
        this.renameProjectInput.setValue(null);
        this.renameProjectInputError = false;
        this.selectedRenameProject = null;  
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = res.body.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.dismiss();
      this.showSpinnerLoader = false;
    }, (err) => {
      this.errorMessage = err.error.message;
      setTimeout(() => this.errorMessage = '', 5000);
      this.showSpinnerLoader = false;
    })
  }

  /**
   * Methos to use open handle back event model
   */
  openHandleBackEventModel() {
    this.modelService.open(this.handleBackEventModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
  * Methos to use go to project list
  * If user wants to back
  */
  handleBackEvent() {
    this.locationService.back();
  };

  /**
   * Method to handle the dismissal of the project list component.
   */
  dismiss() {
    this.modelService.dismissAll();
    this.showSpinnerLoader = false;
  }

  /**
   *
   * @param string
   * @returns
   */
  chipCleanUp(string: string) {
    var out = string.split(",").map((res) => {
      if (res.includes('.aisearch')) {
        return res.split(".")[0]
      } else {
        return res
      }
    })
    return out.join(",");
  };
    getIndustryIcon(industryName){
      let iconName = GlobalService.getIndustryIcon(industryName.toLowerCase())
      return `fa-solid fa-${iconName}`
    }

}
